import React, { useState, useEffect } from 'react';
import SelectList from '../shared/inputs/SelectList';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import JobEditor from './JobEditor';
import Collapse from 'react-bootstrap/Collapse';

const ProposalSelector = ({
    cancelEdit,
    customerId,
    editId,
    fetchData
}) => {
    const [proposalId, setProposalId] = useState(0);
    const [showSelector, setShowSelector] = useState(false);

    useEffect(() => {
        setProposalId(0);
        if (editId === 0) {
            setShowSelector(true);
        } else {
            setShowSelector(false);
        }
    }, [editId]);

    useEffect(() => {
        if (proposalId !== 0) {
            setShowSelector(false);
        }
    }, [proposalId]);

    const cancelSelection = () => {
        cancelEdit();
    }

    const selectProposal = (id) => {
        setShowSelector(false);
        setProposalId(id);
    }

    return (
        <React.Fragment>
            <Collapse in={showSelector}>
                <div>
                    <div className="item-editor pt-3">
                        <Row>
                            <Col sm="auto">
                                <Form.Label>
                                    Select a Proposal:
                                </Form.Label>
                            </Col>
                            <Col>
                                {//force the select list to update when we show it
                                    showSelector &&
                                    <SelectList
                                        filter={{ customerId: customerId }}
                                        lookupType="Proposal"
                                        onChange={({ target: { value } }) => selectProposal(value)}
                                        placeholder="Proposal"
                                        required
                                        value={0}
                                    />
                                }
                            </Col>
                            <Col xs="auto">
                                <span className="action-button cancel-button"
                                    onClick={() => cancelSelection()}>Cancel</span>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Collapse>
            <JobEditor
                cancelEdit={cancelSelection}
                customerId={customerId}
                editId={editId}
                fetchData={fetchData}
                proposalId={proposalId}
            />
        </React.Fragment>
    );
}

export default ProposalSelector;